import PublicPage from '@/shared/PublicPage/PublicPage';

export default function FullFilmentPolicy() {
  return (
    <PublicPage withFooter>
      <h1>FULFILLMENT POLICY</h1>
      <br />

      <h2>Subscription Access and Digital Content Delivery</h2>
      <p>
        Welcome to Rockalingua! We specialize in providing engaging and
        educational content to assist in learning languages. Upon purchasing a
        subscription, customers gain immediate access to our extensive library
        of educational materials, which include but are not limited to songs,
        videos, games, and worksheets. As our offerings are purely digital and
        accessed via an online subscription, there are no physical products
        shipped to our customers.
      </p>

      <h2>Accessing Your Subscription</h2>
      <p>
        Upon completion of your purchase, you will receive a confirmation email
        that will include detailed instructions on how to access your new
        Rockalingua subscription. You will have immediate access to all the
        content within your chosen subscription tier. If you encounter any
        issues accessing the content, please contact our customer support team
        for prompt assistance.
      </p>

      <h2>Refund Policy</h2>
      <p>
        We are committed to ensuring that you are completely satisfied with your
        Rockalingua experience. If you find that our services do not meet your
        educational needs, we offer a refund policy under the following
        conditions:
      </p>
      <ul>
        <li>
          <strong>Full Refund:</strong> Customers may request a full refund
          within 30 days of the initial purchase.
        </li>
        <li>
          <strong>Cancellation Policy:</strong> You may cancel your subscription
          at any time. The cancellation will be effective at the end of the
          current billing cycle, and you will retain access to your subscription
          until that time. No additional charges will be incurred once the
          cancellation is processed.
        </li>
        <li>
          <strong>No Refund:</strong> After 30 days from the subscription start
          date, we are unable to offer refunds.
        </li>
      </ul>

      <h2>Requesting a Refund or Cancellation</h2>
      <p>
        To request a refund or cancel your subscription, please contact our
        customer service team with your account details and purchase
        information. We will process your request as quickly as possible.
      </p>

      <h3>Customer Service Contact Information:</h3>
      <p>
        Email: <a href="mailto:info@rockalingua.com">info@rockalingua.com</a>
        <br />
        Phone: <a href="tel:+4157133537">415 713 3537</a>
        <br />
        Hours of Operation: 9am to 5pm PT
      </p>

      <p>
        Please note that refund requests may take up to 7-10 business days to
        process, and the funds will be credited to the original method of
        payment.
      </p>

      <h2>Changes to Subscription Plans</h2>
      <p>
        We understand that your educational needs may change over time. You are
        welcome to upgrade or downgrade your subscription plan at any point
        during your subscription period. Adjustments to your plan will be
        reflected in the next billing cycle.
      </p>

      <h2>Terms and Conditions</h2>
      <p>
        By purchasing a subscription with Rockalingua, you agree to our Terms of
        Service and Privacy Policy. Please review these documents carefully to
        understand your rights and obligations.
      </p>

      <h2>Customer Feedback</h2>
      <p>
        We continually strive to improve our offerings and value the feedback
        from all our subscribers. If you have suggestions, concerns, or
        feedback, please reach out to us via our customer service channels.
      </p>

      <p>
        We thank you for choosing Rockalingua for your educational journey and
        look forward to supporting your language learning adventures!
      </p>
    </PublicPage>
  );
}
